import { createSlice } from "@reduxjs/toolkit"

const filesAndFoldersSlice = createSlice({
   name: "filesAndFolders",
   initialState: {
      filesAndFolders: null,
      loading: false,
   },
   reducers: {
      getFilesAndFoldersLoading: (state) => {
         state.loading = true
      },
      getFilesAndFoldersSuccess: (state, action) => {
         state.filesAndFolders = action.payload
         state.loading = false
      },
      getFilesAndFoldersFailure: (state) => {
         state.loading = false
      },
   },
})

export const {
   getFilesAndFoldersLoading,
   getFilesAndFoldersSuccess,
   getFilesAndFoldersFailure,
} = filesAndFoldersSlice.actions

export default filesAndFoldersSlice.reducer
